var map = {
	"./google-play-badge-da-DK.svg": 99783,
	"./google-play-badge-de-DE.svg": 15317,
	"./google-play-badge-en-GB.svg": 93463,
	"./google-play-badge-en-US.svg": 43200,
	"./google-play-badge-es-ES.svg": 2359,
	"./google-play-badge-es-MX.svg": 8996,
	"./google-play-badge-fr-FR.svg": 41496,
	"./google-play-badge-it-IT.svg": 94141,
	"./google-play-badge-nb-NO.svg": 78886,
	"./google-play-badge-nl-NL.svg": 40483,
	"./google-play-badge-pl-PL.svg": 86375,
	"./google-play-badge-pt-BR.svg": 41127,
	"./google-play-badge-pt-PT.svg": 54135,
	"./google-play-badge-sv-SE.svg": 25574
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31724;